export const DEFAULT_TIMES = {
	TO_ACCEPT: 30,
	TO_PICK: 90,
	DAYS_TO_CANCEL: 10,
};

export const IPAD_COOKIES = {
	sessionid: "sessionid",
};

export const S2S_COOKIES = {
	s2s_vendor_sandbox_token: "s2s-vendor-sandbox-token",
};

export function splitDocumentCookies() {
	if (!document) {
		return {};
	}

	const cookies: { [key: string]: string } = {};
	const pairs = document.cookie.split(";");
	for (let i = 0; i < pairs.length; i++) {
		const pair = pairs[i].split("=");
		cookies[(pair[0] + "").trim()] = unescape(pair.slice(1).join("="));
	}

	return cookies;
}
/** ensures that all cookies are set, otherwise the app will not work as intended */
export function areCookiesValid(cookies: any) {
	if (!cookies) {
		return false;
	}

	let valid = true;
	// console.log("\r\n");
	Object.values(IPAD_COOKIES).forEach((cookie) => {
		const val = cookies[cookie];
		// console.log(`++${cookie}-${val}++`);
		if (!val || ["undefined", "null", "0"].includes(val)) {
			valid = false;
		}
	});
	// console.log({ valid, cookies }, "\r\n");

	return valid;
}

export const OVERRIDES = {
	time_accept: "override_accept_time",
	time_pick: "override_picking_time",
	time_token: "override_token",
};

/**
 * 1. if a new order (status: Pending) is received while the store is open:
 * 	- cancel the order
 * 	- if the store is closed, wait until the store is open next
 *
 * 2. if an accepted order (status: Picking) has it's picking time passed
 * 	- cancel the order
 */

export const OrderTimeoutdReasons = {
	ORDER_TOO_OLD: "Order too old.",
	PENDING_ORDER_TIMEOUT: "Pending Order - acceptance time expired.",
	PICKING_ORDER_TIMEOUT: "Picking Order - picking time expired.",
};
